import PrimaryButton from '@components/atoms/buttons/PrimaryButton';
import GridBox from '@components/atoms/GridBox';
import Section from '@components/atoms/Section';
import PageContainer from '@components/molecules/PageContainer';
import DefaultHeader from '@components/organisms/headers/DefaultHeader';
import COLORS from '@lib/constants/colors';
import airtableBases, { CarrierComparative } from '@lib/helpers/airtableBases';
import { useCompareCarrierModal } from '@lib/hooks/modal';
import { GetStaticProps } from 'next';
import React from 'react';

interface Props {
  carriers: CarrierComparative[];
}

const Page = ({ carriers }: Props) => {
  const [showModal] = useCompareCarrierModal({
    carriers,
    carriersToCompare: [],
  });
  return (
    <PageContainer
      title="Qual seguradora é melhor para carro ou moto"
      metaDescription="Qual a melhor seguradora de moto? E a melhor seguro pra carro? Descubra o melhor seguro auto com esse comparativo"
      transparentNavbar
      transparentNavbarFontColor={COLORS.black}
    >
      <DefaultHeader
        pastel
        title="Descubra qual a melhor seguradora"
        subtitle="Veja as diferenças de cobertura, preço, avaliação e muito mais"
      />
      <Section pastel style={{paddingTop:0}}>
        <GridBox justifyContent="center">
          <PrimaryButton pink boxShadow onClick={showModal}>
            Escolher Seguradoras
          </PrimaryButton>
        </GridBox>
      </Section>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const carriers = await airtableBases.getCarriers();

  return {
    props: { carriers },
    revalidate: 3600,
  };
};

export default Page;
